// extracted by mini-css-extract-plugin
var _1 = "RichTextDescriptionEditor-module__container--i5WIl";
var _2 = "RichTextDescriptionEditor-module__editorContainer--IBSoK";
var _3 = "RichTextDescriptionEditor-module__editorRoot--iHfJu";
export { _1 as "container", _2 as "editorContainer", _3 as "editorRoot" }
